  import * as ActionTypes from "../Types/ActionTypes";

  export const Dashboard = (
    state = {
      isLoading: false,
      dashboardState: null,
    },
    action
  ) => {
    switch (action.type) {
      case ActionTypes.DASHBOARD_LOADER_START:
        return {
          ...state,
          isLoading: true,
        };

      case ActionTypes.DASHBOARD:
        return {
          ...state,
          isLoading: false,
          dashboardState: action.payload,
        };

      case ActionTypes.DASHBOARD_LOADER_STOP:
        return {
          ...state,
          isLoading: false,
        };

      default:
        return state;
    }
  };
